//为了防止同时缓存token的
export function setLocalStorageForUser(token,type , val) {

    const key = `${type}_${token}`
    localStorage.setItem(key, val)
}

export function getLocalStorageForUser(token,type) {
    const key = `${type}_${token}`
    return localStorage.getItem(key)
}

export function removeLocalStorageForUser(token,type) {
    const key = `${type}_${token}`
    localStorage.removeItem(key)
}